<template lang="pug">
div
    AdminSubnav
    .mt-3
        router-view
</template>

<script>
import AdminSubnav from "./admin/AdminSubnav.vue";

const ADMIN_TAB_KEY = "admin_last_tab";
const DEFAULT_ADMIN_TAB = "/admin/access";

export default {
    components: {AdminSubnav},
    created() {
        this.persistCurrentTab(this.$route.path);
    },
    watch: {
        $route(to) {
            this.persistCurrentTab(to.path);
        }
    },
    methods: {
        persistCurrentTab(path) {
            if (typeof path !== "string") return;
            if (!path.startsWith("/admin/")) return;
            localStorage.setItem(ADMIN_TAB_KEY, path);
        }
    }
};
</script>
